import React, { Component } from "react";

import Header from "@components/Header";

class ModsClients extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>ModsClients</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default ModsClients;
